import { connect } from 'react-redux';
import { syncRequiredSkills } from '../../../../app/job-creation/job-creation.actions';
import { getAllSkills } from '../../../../app/main/main.actions';
import { RequiredSkills } from './required-skills';

const mapStateToProps = state => {
  return {
    skillCategories: state.main.allSkills,
    requiredSkills: state.jobCreation.requiredSkills,
    requiredSkillsList: state.jobCreation.requiredSkillsList,
    showError: state.jobCreation.showValidationErrors,
    optionalSkills: state.jobCreation.additionalPreference.skills,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleRequiredSkillsChange: requiredSkills => {
      dispatch(syncRequiredSkills(requiredSkills));
    },
    getAllSkills: () => {
      dispatch(getAllSkills());
    },
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(RequiredSkills);
export { connected as RequiredSkillsContainer };
